import React, { useState, useEffect } from 'react';

const COOKIE_KEY = 'arcanapp_cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisible(false);
  };

  const handleRefuse = () => {
    localStorage.setItem(COOKIE_KEY, 'refused');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={styles.container} data-testid="cookie-consent-banner">
      <div style={styles.content}>
        <div style={styles.icon}>🍪</div>
        <div style={styles.textContainer}>
          <p style={styles.title}>Cookies & Confidentialité</p>
          <p style={styles.text}>
            Ce site utilise des cookies et traceurs pour améliorer votre expérience.
            Conformément au RGPD et à la directive ePrivacy, vous pouvez accepter ou refuser leur utilisation.
          </p>
        </div>
        <div style={styles.buttons}>
          <button
            onClick={handleRefuse}
            style={styles.refuseBtn}
            data-testid="cookie-refuse-btn"
          >
            Refuser
          </button>
          <button
            onClick={handleAccept}
            style={styles.acceptBtn}
            data-testid="cookie-accept-btn"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    position: 'fixed',
    bottom: 20,
    left: 20,
    zIndex: 9999,
    maxWidth: 420,
    animation: 'slideUp 0.4s ease-out',
  },
  content: {
    background: '#1a1d2e',
    border: '1px solid #2a2d3e',
    borderRadius: 16,
    padding: '20px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  icon: {
    fontSize: 28,
  },
  textContainer: {
    flex: 1,
  },
  title: {
    color: '#fff',
    fontWeight: 700,
    fontSize: 15,
    margin: '0 0 6px 0',
  },
  text: {
    color: '#9ca3af',
    fontSize: 13,
    lineHeight: '1.5',
    margin: 0,
  },
  buttons: {
    display: 'flex',
    gap: 8,
    marginTop: 4,
  },
  refuseBtn: {
    flex: 1,
    padding: '10px 16px',
    borderRadius: 10,
    border: '1px solid #3a3d4e',
    background: 'transparent',
    color: '#9ca3af',
    fontWeight: 600,
    fontSize: 13,
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
  acceptBtn: {
    flex: 1,
    padding: '10px 16px',
    borderRadius: 10,
    border: 'none',
    background: '#7c3aed',
    color: '#fff',
    fontWeight: 600,
    fontSize: 13,
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
};
